import { defineStore } from 'pinia';
import { useListShapes, type ListShapeResponse } from '../api/listShapes';
import { useShapeStore } from 'shared/shapes/stores/shapeStore';
import { useRefreshStore } from '@/common/composables/refreshStore';

export const useRefreshShapeStore = defineStore('refresh-shapes', () => {
  const listShapes = useListShapes();
  const store = useShapeStore();

  const { initialize, refresh } = useRefreshStore<ListShapeResponse>({
    fetchFromServer() {
      return listShapes.execute();
    },

    mergeToStore(response) {
      store.merge(response.shapes);
    },
  });

  return {
    initialize,
    refresh,
  };
});
